import { render, staticRenderFns } from "./ProductosAgotados.vue?vue&type=template&id=e8cb7c00"
import script from "./ProductosAgotados.vue?vue&type=script&lang=js"
export * from "./ProductosAgotados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports